document.addEventListener('DOMContentLoaded', function() {
  let isProcessing = false;
  let isReturnFromCheckout = false;
  
  // Check if manually bypassing the checkout detection (for debugging)
  const forcePromo = new URLSearchParams(window.location.search).get('forcePromo');
  if (forcePromo === 'true') {
    localStorage.removeItem('checkoutTimestamp');
  } else {
    // Check if the user is returning from checkout (with more lenient timing)
    const checkoutTimestamp = localStorage.getItem('checkoutTimestamp');
    const currentTime = Date.now();
    
    if (checkoutTimestamp && (currentTime - parseInt(checkoutTimestamp)) < 30000) { // 30 seconds instead of 60
      isReturnFromCheckout = true;
      
      // Reset the flag after a shorter delay
      setTimeout(() => {
        isReturnFromCheckout = false;
        localStorage.removeItem('checkoutTimestamp');
      }, 3000); // 3 seconds instead of 5
    } else if (document.referrer.includes('/checkout')) {
      isReturnFromCheckout = true;
      
      // Reset the flag after a shorter delay
      setTimeout(() => {
        isReturnFromCheckout = false;
      }, 3000); // 3 seconds instead of 5
    }
  }

  async function reloadCartDrawer() {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      // Fetch cart sections
      const response = await fetchWithRetry(`${routes.cart_url}?section_id=cart-drawer`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart items
      const sourceQty = doc.querySelector('cart-drawer-items');
      const targetQty = document.querySelector('cart-drawer-items');
      if (targetQty && sourceQty) {
        targetQty.innerHTML = sourceQty.innerHTML;
      }

      // Update cart footer
      const sourceFooter = doc.querySelector('.drawer__footer');
      const targetFooter = document.querySelector('.drawer__footer');
      if (targetFooter && sourceFooter) {
        targetFooter.innerHTML = sourceFooter.innerHTML;
      }

      // Handle empty state
      const cartResponse = await fetchWithRetry('/cart.js');
      const cart = await cartResponse.json();
      const isEmpty = !cart.items || cart.items.length === 0;

      if (isEmpty) {
        cartDrawer.classList.add('is-empty');
        if (targetQty) targetQty.classList.add('is-empty');
      } else {
        cartDrawer.classList.remove('is-empty');
        if (targetQty) targetQty.classList.remove('is-empty');
        
        // Remove empty content if it exists
        const emptyContent = cartDrawer.querySelector('.drawer__inner-empty');
        if (emptyContent) {
          emptyContent.remove();
        }
      }

      // Ensure the drawer is visible
      cartDrawer.style.display = '';
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      // Dispatch cart update event
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

    } catch (error) {
      console.error('Error reloading cart drawer:', error);
    }
  }

  // Add a retry mechanism for network operations
  async function fetchWithRetry(url, options, maxRetries = 3) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Request failed with status ${response.status}: ${errorText}`);
        }
        return response;
      } catch (error) {
        retries++;
        if (retries >= maxRetries) throw error;
        // Exponential backoff
        await new Promise(resolve => setTimeout(resolve, 200 * Math.pow(2, retries)));
      }
    }
  }

  // Helper function to handle empty cart state
  async function handleEmptyCartState() {
    try {
      // Get updated cart data to confirm it's empty
      const updatedCartResponse = await fetchWithRetry('/cart.js');
      const updatedCart = await updatedCartResponse.json();
      
      if (!updatedCart.items || updatedCart.items.length === 0) {
        // Force the cart drawer to show empty state
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('is-empty');
          
          // Get the cart drawer items element
          const cartItems = document.querySelector('cart-drawer-items');
          if (cartItems) {
            cartItems.classList.add('is-empty');
            cartItems.innerHTML = '';
          }
          
          // Fetch the empty cart template
          const emptyCartResponse = await fetchWithRetry(`${window.location.origin}?section_id=cart-drawer`);
          const emptyCartHtml = await emptyCartResponse.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(emptyCartHtml, 'text/html');
          
          // Get the empty drawer content
          const emptyDrawerContent = doc.querySelector('.drawer__inner-empty');
          if (emptyDrawerContent) {
            // Find or create the empty drawer container
            let currentEmptyDrawer = document.querySelector('.drawer__inner-empty');
            if (!currentEmptyDrawer) {
              currentEmptyDrawer = document.createElement('div');
              currentEmptyDrawer.classList.add('drawer__inner-empty');
              const drawerInner = document.querySelector('.drawer__inner');
              if (drawerInner) {
                drawerInner.appendChild(currentEmptyDrawer);
              }
            }
            
            // Update the empty drawer content
            currentEmptyDrawer.innerHTML = emptyDrawerContent.innerHTML;
          }
          
          // Force open the drawer
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
          
          // Dispatch standard Shopify events
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        }
      } else {
        // Cart is not empty, do normal reload
        await reloadCartDrawer();
      }
    } catch (error) {
      console.error('Error handling empty cart state:', error);
      // Try standard reload as fallback
      await reloadCartDrawer();
    }
  }

  // Improve the debounce function to better handle race conditions
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      // Cancel any pending executions
      clearTimeout(timeout);
      
      // Schedule new execution
      timeout = setTimeout(() => {
        // Only execute if not currently processing
        if (!isProcessing) {
          func(...args);
        }
      }, wait);
    };
  }

  // Store timeout IDs for better management
  const timeouts = {};

  function safeSetTimeout(callback, delay, id) {
    // Clear any existing timeout with this ID
    if (timeouts[id]) {
      clearTimeout(timeouts[id]);
    }
    
    // Set new timeout and store its ID
    timeouts[id] = setTimeout(() => {
      callback();
      delete timeouts[id]; // Clean up reference
    }, delay);
    
    return timeouts[id];
  }
}); 